import { formatDate, parseIsoDateTime } from '@ninja/utilities';
import { PolicyType, priceFormatter } from '../../../../common';
import { useAppPlatformContextOptions } from '../../../../contexts/app';
import { selectMembers, useQuoteStore } from '../../../../stores';

export type PlanPrice = {
	quoteResponseId: number;
	memberPrice: number;
	planId: number;
	memberId: string;
	memberPriceIncludingVAT: number;
};

type MemberListProps = {
	planPrices: Record<string, PlanPrice>;
};

export const useMemberList = ({ planPrices }: MemberListProps) => {
	const { translate } = useAppPlatformContextOptions();
	const members = useQuoteStore(selectMembers);
	const { memberId = '', dateOfBirth = '', gender = '', nationality = '' } = members?.principalDetails ?? {};

	const mappedPrices = [
		...(members?.policyType === PolicyType.OnlyMe || members?.policyType === PolicyType.MeAndFamily
			? [
					{
						id: memberId,
						member: translate('quote-list:quote-benefits-modal.member-list-content.principal'),
						gender,
						dateOfBirth: formatDate(parseIsoDateTime(dateOfBirth)) ?? '',
						nationality,
						priceExcVAT: translate('common:shared.currency', {
							amount: priceFormatter(planPrices[memberId]?.memberPrice ?? 0),
						}),
						priceIncVAT: translate('common:shared.currency', {
							amount: priceFormatter(planPrices[memberId]?.memberPriceIncludingVAT ?? 0),
						}),
						type: translate('quote-list:quote-benefits-modal.member-list-content.sponsor'),
					},
			  ]
			: []),
		...(members?.dependents ?? []).map((member) => {
			return {
				id: member.memberId,
				member: member.relationship ?? '',
				gender: member.gender ?? '',
				dateOfBirth: formatDate(parseIsoDateTime(member?.dateOfBirth)) ?? '',
				nationality: member.nationality ?? '',
				priceExcVAT: translate('common:shared.currency', {
					amount: priceFormatter(planPrices[member.memberId]?.memberPrice ?? 0),
				}),
				priceIncVAT: translate('common:shared.currency', {
					amount: priceFormatter(planPrices[member.memberId]?.memberPriceIncludingVAT ?? 0),
				}),
				type: translate('quote-list:quote-benefits-modal.member-list-content.dependent'),
			};
		}),
	];

	return { fetchGridSampleData: mappedPrices };
};
